import { Component, OnInit } from '@angular/core';
import { MatRadioChange } from '@angular/material';
import { SucursalesService } from '../../services/sucursales.service';
import { DatesHelpersService } from '../../services/tools/dates-helpers.service';
import { HelpersService } from '../../services/tools/helpers.service';
import {Location} from '@angular/common';
import { FondeadoresService } from '../../services/fondeadores.service';
import { ActivatedRoute } from '@angular/router';
import { SocioFondeadorService } from '../../services/socio-fondeador.service';
declare var $;

@Component({
  selector: 'app-registro-socio-fondeador',
  templateUrl: './registro-socio-fondeador.component.html',
  styleUrls: ['./registro-socio-fondeador.component.scss']
})
export class RegistroSocioFondeadorComponent implements OnInit {

  public errors:any = {};
  public isLoading: boolean = false;
  //Variable del ngModel del form para fondeador
  public fondeador: any = {};
  public opcTipoEntidad :string="";
  //Sucursales
  public sucursales: any[] = [];
  public sucursalSelected: any = {id:null};
  public sucursalPorDefecto: string = "";
  //Tipo de fondeador
  public tipo_fondeador: string = "";
  public esAhorrador:boolean = false;
  public esInversionista:boolean = false;
  public tipoInversionista:boolean = true;
  //Empresas
  public empresa: any = {id:null};
  public empresasOpc: any[] = [];
  public empresaPorDefecto: string = "";
  //Tipos de fondeador
  public tiposFondeador: string[] = ['ahorrador', 'inversionista'];
  //Plazas
  public plazas: any = {id:null};
  public plazasOpc: any[] = [];
  public plazaPorDefecto: string = "";
  //Promotores
  public promotores: any[] = [];
  public promotorSelected: any = {id:null};
  public promotorPorDefecto: string = "";
  //Actualizar
  public isUpdate : boolean = false;
  public idFondeador : number = 0;
  public isPersonaFisica: boolean = false;

  //Para el archivo
  public fileList_INE: FileList;
  public fileList_Comprobante: FileList;
  public fileList_RFC: FileList;

  public archivo_ine: string = "";
  public archivo_dom: any = null;
  public archivo_rfc: any = null;

  constructor(
    public location : Location,
    private datesHelper : DatesHelpersService,
    private sucursalesService: SucursalesService,
    private fondeadoresService: FondeadoresService,
    private socioFondeadorService: SocioFondeadorService,
    private helperService: HelpersService,
    private activatedRoute : ActivatedRoute
  ) { }

  ngOnInit() {
    this.getSucursales();
    // this.getPromotores();

    this.idFondeador = this.activatedRoute.snapshot.params.idSocio;
    if(this.idFondeador != undefined){
      this.isUpdate = true;
      console.log("Trae ID: ", this.idFondeador);
      this.obtFondeadorId(this.idFondeador);
    }else{
      console.log("Es registrar");
      
    }

    this.fondeador = this.socioFondeadorService.getDefaultSchedule();
    
  }

  private getSucursales(){
    this.sucursalesService.getSelect().subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.sucursales = jsonResult.content;
          console.log("La sucursales: ", this.sucursales);
          if (this.sucursales.length>1){
            this.sucursalPorDefecto = "Seleccione";
          } else if(this.sucursales.length>0){
            this.sucursalSelected =  this.sucursales[0];
            console.log("Sucursal: ",this.sucursalSelected);
          }
          //this.getGastos();
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  //Cambiar select sucursales
  private selectSucursal(sucursal){
    let component = this;
    this.sucursales.forEach(function(tipo) {
      if(tipo.id === sucursal){
        component.sucursalSelected = tipo;
      }
    });
  }

  sucursalChanged(sucursal){
    console.log("Event Sucursal: ", sucursal);
    
    if(sucursal){
        this.sucursalSelected = sucursal;
        console.log("Sucursal: ",this.sucursalSelected.id);
        // this.getGastosPorMes();
    }
  }

  //Promotores
  private getPromotores(){
    this.sucursalesService.getSelect().subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.promotores = jsonResult.content;
          console.log("Los promotores: ", this.promotores);
          if (this.promotores.length>1){
            this.promotorPorDefecto = "Seleccione";
          } else if(this.promotores.length>0){
            this.promotorSelected =  this.promotores[0];
            console.log("Sucursal: ",this.promotorSelected);
          }
          //this.getGastos();
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  //Obtener Fondeador por ID para actualizar
  public obtFondeadorId(id:number){
    this.isLoading = true;
    this.socioFondeadorService.getSocioEspecifico(this.idFondeador).subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        console.log("Json: ", jsonResult);
        
        if(jsonResult.content){
          this.fondeador = jsonResult.content;
          console.log("Fondeador ID: ", this.fondeador);
          this.selectSucursal(this.fondeador.idSucursal);
          this.opcTipoEntidad = this.fondeador.tipo_entidad;
          //Tipo de persona
          if(this.fondeador.tipo_entidad === "fisica"){
            this.isPersonaFisica = true;
          }
          //Tipos de fondeadores
          if(this.fondeador.tipo_fondeador === "ahorrador"){
            this.selectEmpresa(this.fondeador.idEmpresa)
            this.esAhorrador = true;
          }

          if(this.fondeador.tipo_fondeador === "inversionista"){
            this.selectPlaza(this.fondeador.plaza)
            this.esInversionista = true;
          }
          this.isLoading = false;
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }


  public getTipoEntidad(){
    
    if(this.opcTipoEntidad === "fisica")
      this.isPersonaFisica = true;
    else
      this.isPersonaFisica = false;
  }

  public aceptar(){
    this.errors = [];
    
    if(this.sucursalSelected.id === null){
      this.fondeador.idSucursal = "";
    }
    else
    {
      this.fondeador.idSucursal = this.sucursalSelected.id;
    }
    
    if(this.opcTipoEntidad.length < 1){
      this.fondeador.tipo_entidad = "";
    }
    else
    {
      this.fondeador.tipo_entidad = this.opcTipoEntidad;
    }

    //Validar tipo de fondeador
    //Validaciones para la plaza y las empresas
    // if(this.fondeador.tipo_fondeador === ""){
    //   this.fondeador.plaza = null;
    //   this.fondeador.idEmpresa = null;
    // } 

    //Funcion para validar campos del fondeador
    this.errors = this.socioFondeadorService.validarSocio(this.fondeador);
    
    if(!$.isEmptyObject(this.errors)){
      return false;
    }
    console.log("Datos socio: ", this.fondeador);
    this.registrarNuevoSocio();
  }

  //Registrar socio
  public registrarNuevoSocio(){
    //console.log("Datos Ben: ",this.beneficiario);
    let formData : FormData = new FormData();
    //Armamos el formData
    formData.append("tipo_fondeador", this.fondeador.tipo_fondeador);
    formData.append("nombre", this.fondeador.nombre);
    formData.append("email", this.fondeador.email);
    formData.append("idSucursal", this.fondeador.idSucursal);
    formData.append("telefono", this.fondeador.telefono);
    formData.append("tipo_entidad", this.fondeador.tipo_entidad);
    formData.append("rfc", this.fondeador.rfc);
    formData.append("direccion", this.fondeador.direccion);
    formData.append("saldo", (this.fondeador.saldo));
    formData.append("clave_elector", this.fondeador.clave_elector);
    
    if( this.fondeador.archivo_ine != null && this.fondeador.archivo_ine.length > 0){
      let file_ine: File = this.fondeador.archivo_ine[0];
      formData.append("archivo_ine", file_ine);
    }else{
      formData.append("archivo_ine", null);
    }
    if(this.fondeador.archivo_domicilio != null && this.fondeador.archivo_domicilio.length > 0){
      let file_comp: File = this.fondeador.archivo_domicilio[0];
      formData.append("archivo_domicilio", file_comp);
    }else{
      formData.append("archivo_domicilio", null);
    }
    if(this.fondeador.archivo_rfc != null && this.fondeador.archivo_rfc.length > 0){
      let file_rfc: File = this.fondeador.archivo_rfc[0];
      formData.append("archivo_rfc", file_rfc);
    }else{
      formData.append("archivo_rfc", null);
    }
    //Llamamos al servicio
    this.socioFondeadorService.registrarSocioFondeador(formData)
      .subscribe(response => {
        const datosFondeador = response.json();

        console.log("Resp service socio-fondeador: ",datosFondeador);
        if (datosFondeador.success) {
          this.helperService.notification('Fondeador agregado', 'Se ha creado exitosamente el fondeador', 'success');
          setTimeout(() => {this.location.back()},3000);
          
        }
      }, error => {
        //this.processing = false;
        if(error.status == 400) {
          this.showServicesErrors(error.json().content);
          this.helperService.notification('ERROR', 'El tamaño del archivo no puede ser mayor a 2 MB.', 'error');
        }else{
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
        
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);
      });
  }

  //Actualizar socio
  public actualizar(){
    this.errors = [];
    if(this.sucursalSelected.id === null){
      this.fondeador.idSucursal = "";
    }
    else
    {
      this.fondeador.idSucursal = this.sucursalSelected.id;
    }
    
    if(this.opcTipoEntidad.length < 1){
      this.fondeador.tipo_entidad = "";
    }
    else
    {
      this.fondeador.tipo_entidad = this.opcTipoEntidad;
      if(this.fondeador.tipo_entidad == "moral"){
        this.fondeador.clave_elector = null;
      }
    }


    //Funcion para validar campos del fondeador
    this.errors = this.socioFondeadorService.validarSocio(this.fondeador);
    
    if(!$.isEmptyObject(this.errors)){
      return false;
    }
    console.log("Datos actualizar: ", this.fondeador);
    
    this.actualizarSocioFondeador();

  }

  //Actualizar fondeador
  public actualizarSocioFondeador(){
    this.socioFondeadorService.update(this.fondeador.id,this.fondeador)
      .subscribe(response => {
        if (response.json().success) {
          this.helperService.notification('Socio actualizado', 'Se ha actualizado exitosamente el fondeador: ' + this.fondeador.nombre, 'success');
          setTimeout(() => {this.location.back()},3000);
        }
      }, error => {
        if(error.status == 400) {
          this.showServicesErrors(error.json().content);
        }else{
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }

        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
    });
  }

  //Cambiar plazas
  private selectPlaza(plazaSelect){
    let component = this;
    this.plazasOpc.forEach(function(tipo) {
      if(tipo.nombre === plazaSelect){
        component.plazas = tipo;
      }
    });
  }
  //Cambiar empresas
  private selectEmpresa(empresaSelect){
    let component = this;
    this.empresasOpc.forEach(function(tipo) {
      if(tipo.id === empresaSelect){
        component.empresa = tipo;
      }
    });
  }

  public addPlazas(){
    this.plazasOpc = [{ id: 1, nombre: "CC"}, {id: 2, nombre: "AA"}, {id: 3, nombre: "AC"} ];
    
    if (this.plazasOpc.length>1){
      this.plazaPorDefecto = "Seleccione";
    } else if(this.plazasOpc.length>0){
      this.plazas =  this.plazasOpc[0];
    }
    
  }
  //Saber la empresa seleccionada
  public empresasChanged(empresaSelect){
    if(empresaSelect){
      this.empresa = empresaSelect;
      console.log("Empresa seleccionada: ", this.empresa);
      
    }
  }

  public plazasChanged(plaza){
    if(plaza){
      this.plazas = plaza;
      console.log("Plaza : ",this.plazas);
    }
  }

  public radioChange($event: MatRadioChange) {
    console.log($event.source.name, $event.value);

    if ($event.value === 'ahorrador') {
      this.esAhorrador = true;
      this.tipo_fondeador = "Ahorrador";
      this.esInversionista = false;
      this.tipoInversionista = false;
    }else if($event.value === 'inversionista'){
      this.esAhorrador = false;
      this.tipo_fondeador = "Inversionista";
      this.esInversionista = true;
      this.tipoInversionista = true;
    }
  }

  //Files
  public uploadFile(event : any, tipo: string) {
    // console.log("File: ", event, "Tipo: ", tipo);
    console.log("Cargar");
    
    switch(tipo){
      case 'ine':
        this.fileList_INE = event.target.files;
        console.log("INE: ", this.fileList_INE, "Tipo: ", tipo);
        if(this.fileList_INE.length > 0) {
          let file_1: File = this.fileList_INE[0];
          this.archivo_ine = file_1.name;
          this.fondeador.archivo_ine = this.fileList_INE;
        }
        break;
      case 'comprobante':
        this.fileList_Comprobante = event.target.files;
        console.log("Dom: ", this.fileList_Comprobante, "Tipo: ", tipo);
        if(this.fileList_Comprobante.length > 0) {
          let file_2: File = this.fileList_Comprobante[0];
          this.archivo_dom = file_2.name;
          this.fondeador.archivo_domicilio = this.fileList_Comprobante;
        }
        break;
      case 'rfc':
        this.fileList_RFC = event.target.files;
        console.log("RFC: ", this.fileList_RFC, "Tipo: ", tipo);
        if(this.fileList_RFC.length > 0) {
          let file_3: File = this.fileList_RFC[0];
          this.archivo_rfc = file_3.name;
          this.fondeador.archivo_rfc = this.fileList_RFC;
        }
        break;
      default :
        console.log("Selecciona algún archivo");
        
    }
    
  }

  public deleteFile(tipo: string){
    switch(tipo){
      case 'ine':
        this.fileList_INE = null;
        console.log("INE: ", this.fileList_INE, "Tipo: ", tipo);
        this.archivo_ine = "";
        this.fondeador.archivo_ine = "";
        break;
      case 'comprobante':
        this.fileList_Comprobante = null;
        console.log("Dom: ", this.fileList_Comprobante, "Tipo: ", tipo);
        this.archivo_dom = "";
        this.fondeador.archivo_domicilio = "";
        break;
      case 'rfc':
        this.fileList_RFC = null;
        console.log("RFC: ", this.fileList_RFC, "Tipo: ", tipo);
        this.archivo_rfc = "";
        this.fondeador.archivo_rfc = "";
        break;
      default :
        console.log("Borrar archivo");
        
    }
  }

  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }

}



// WEBPACK FOOTER //
// ./src/app/modulo-vista/registro-socio-fondeador/registro-socio-fondeador.component.ts